import { useTranslation } from "react-i18next"
import type { TUser } from "@/types"

export const useAnonymous = () => {
  const { t } = useTranslation()
  const name = t("Anonymous")
  return {
    created: Date.now(),
    name,
    full_name: name,
    email: "anonimous@nowhere.com",
    role: "user",
    picture: null,
    position: null,
    source: "internal",
    is_active: true,
  } as TUser
}
